import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";

const AccessDenied = () => {
  return (
    <main className="min-h-screen grid place-items-center bg-background px-6">
      <div className="max-w-md text-center space-y-4">
        <div className="mx-auto h-14 w-14 rounded-full bg-destructive/10 grid place-items-center">
          <ShieldAlert className="h-7 w-7 text-destructive" />
        </div>
        <h1 className="text-2xl font-bold">Access denied</h1>
        <p className="text-muted-foreground">
          You don't have permission to view this page. If you think this is a mistake, contact a system administrator.
        </p>
        <Button asChild variant="outline">
          <Link to="/wallet">Back to wallet</Link>
        </Button>
      </div>
    </main>
  );
};

export default AccessDenied;
